import { render, staticRenderFns } from "./MedicalLeaveList.vue?vue&type=template&id=641b23c0"
import script from "./MedicalLeaveList.vue?vue&type=script&lang=js"
export * from "./MedicalLeaveList.vue?vue&type=script&lang=js"
import style0 from "./MedicalLeaveList.vue?vue&type=style&index=0&id=641b23c0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports